import { useCallback, useState, useMemo, useEffect } from 'react';
import { adminService } from "@api";
import { i18n } from '@common';

const ProgressBar = (props) => {
    const { status, items, reloadTable } = props;
    const [progress, setProgress] = useState({
        min: 0,
        currentData: 0,
        totalData: null,
    });
    const [showCancleBtn, setShowCancleBtn] = useState(false);
    const [studentErrorID, setStudentErrorID] = useState(null);

    useEffect(() => {
        if (items?.datas) {
            setProgress(item => ({
                ...item,
                totalData: items?.datas.length
            }));
            resetPasswordAsync();
        }
    }, [items, resetPasswordAsync]);

    const resetPasswordAsync = useCallback(async () => {
        let errorMassage, currentData = null;
        let temporaryErrorItems = [];
        for (let index = 0; index < items?.datas.length; index++) {
            try {
                const param = items?.datas[index]?.objectId;
                // const param = index === (1 || 2) ? items?.datas[index].objectId : [];
                if (items.from === "resetPassword") {
                    await adminService.studentManagementResetPassword(param).catch((e) => {
                        temporaryErrorItems.push(items?.datas[index].displayName);
                        errorMassage = e;
                    });
                } else if (items.from === "resetFA") {
                    await adminService.studentManagementResetMFA(param).catch((e) => {
                        temporaryErrorItems.push(items?.datas[index].displayName);
                        errorMassage = e;
                    });
                }
                setProgress(item => ({
                    ...item,
                    currentData: item.currentData > item.totalData ? item.totalData : item.currentData + 1
                }));
            } catch (error) {
                temporaryErrorItems.push(items?.datas[index].displayName);
                errorMassage = error;
                // break;
            }
        }
        //Record the information of the student where the error occurred
        setStudentErrorID(temporaryErrorItems?.join().replaceAll(',', '; '));

        //To obtain currentData
        setProgress(item => {
            currentData = item.currentData;
            return item;
        });

        if (errorMassage) {
            $$.toast(failedlMessage, 'error');
            setShowCancleBtn(true);
        } else if (items?.datas.length === currentData && !errorMassage) {
            setTimeout(() => {
                canclePanpel(successfulMessage, '');
            }, 1000);
        }
    }, [canclePanpel, items?.datas, items.from, successfulMessage]);

    const successfulMessage = useMemo(() => {
        if (items.from === "resetPassword") {
            return i18n.get('CIS_Admin_StudentManagement_ResetPassword_Successful_Message');
        } else if (items.from === "resetFA") {
            return i18n.get('CIS_Admin_StudentManagement_ResetFA_Successful_Message');
        }
    }, [items]);

    const failedlMessage = useMemo(() => {
        if (items.from === "resetPassword") {
            return i18n.get('CIS_Admin_StudentManagement_ResetPassword_Failed_Message');
        } else if (items.from === "resetFA") {
            return i18n.get('CIS_Admin_StudentManagement_ResetFA_Failed_Message');
        }
    }, [items, studentErrorID]);

    const canclePanpel = useCallback((successfulMessage, failedlMessage) => {
        setProgress({
            min: 0,
            currentData: 0,
            totalData: null,
        });
        setShowCancleBtn(false);
        if (successfulMessage) {
            reloadTable(true, successfulMessage, 'success');
        } else {
            reloadTable(true);
        }
        setStudentErrorID(null);
    }, [reloadTable]);

    const title = useMemo(() => {
        if (items.from === "resetPassword") {
            return i18n.get('CIS_Admin_StudentManagement_ResetPassword_Title_Entry', progress.currentData, progress.totalData);
        } else if (items.from === "resetFA") {
            return i18n.get('CIS_Admin_StudentManagement_ResetFA_Title_Entry', progress.currentData, progress.totalData);
        }
    }, [items, progress]);

    const cancleClick = () => {
        canclePanpel('', failedlMessage);
    };

    return (
        <>
            {showCancleBtn && status &&
                <div className="aui-loading aui-widget aui-loading-global" id="aui-loading_0" data-index="0" tabIndex="0" aria-labelledby="aui_loading_msg_0" aria-hidden="false" style={{ zIndex: "200", position: "fixed", display: "block" }}>
                    <div id="aui-backdrop-1" className="aui-backdrop aui-backdrop-view-all" data-scroll="false" style={{ width: '1000vw', height: '1000vh' }}></div>
                    <div aria-live="assertive" className="aui-loading-box aui-loading-bg">
                        <div className="aui-loading-dot"><div id="aui_loading_msg_0" className="aui-loading-content-text show">{title}</div>
                            <div className="aui-loading-dot-loading" style={{ width: "300px" }}>
                                <R.Progressbar
                                    id="progressbar-error"
                                    data={[progress.currentData, progress.totalData]}
                                    classify={"error"}
                                />
                            </div>
                        </div>
                        <button id="aui-button-13" className="button button-bald button-default" name="close" aria-label="Close" type="button" style={{ position: 'relative', bottom: '20px', left: '20px' }} onClick={cancleClick}><span className="button-icon-part faui-close" ></span></button>
                    </div>
                </div>
            }
            {!showCancleBtn && status?.show &&
                <div className="aui-loading aui-widget aui-loading-global" id="aui-loading_0" data-index="0" tabIndex="0" aria-labelledby="aui_loading_msg_0" aria-hidden="false" style={{ zIndex: "200", position: "fixed", display: "block" }}>
                    <div id="aui-backdrop-1" className="aui-backdrop aui-backdrop-view-all" data-scroll="false" style={{ width: '1000vw', height: '1000vh' }}></div>
                    <div aria-live="assertive" className="aui-loading-box aui-loading-bg">
                        <div className="aui-loading-dot">
                            <div id="aui_loading_msg_0" className="aui-loading-content-text show">{title}</div>
                            <div className="aui-loading-dot-loading" style={{ width: "300px" }}>
                                <R.Progressbar
                                    id="progressbar-success"
                                    data={[progress.currentData, progress.totalData]}
                                    classify={"success"}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            }
        </>
    );
};

export default ProgressBar;